import { render, staticRenderFns } from "./FindingOtherImages.vue?vue&type=template&id=994052a2&scoped=true"
import script from "./FindingOtherImages.vue?vue&type=script&lang=js"
export * from "./FindingOtherImages.vue?vue&type=script&lang=js"
import style0 from "./FindingOtherImages.vue?vue&type=style&index=0&id=994052a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994052a2",
  null
  
)

export default component.exports